import React from 'react'
import InComeContainer from '../../../Components/InComeContainer/InComeContainer'
import Layout from '../Layout'

const InCome = () => {
  return (
    <Layout><InComeContainer/></Layout>
  )
}

export default InCome